(function($) {

    !function(n){"function"==typeof define&&define.amd?define(["jquery"],n):"object"==typeof module&&module.exports?module.exports=function(o,e){return void 0===e&&(e="undefined"!=typeof window?require("jquery"):require("jquery")(o)),n(e),e}:n(jQuery)}(function(n){n.fn.simplerSidebar=function(o){var e=n.extend(!0,{attr:"simplersidebar",top:0,gap:0,zIndex:3e3,sidebar:{width:400},animation:{duration:300,easing:"swing"},events:{on:{animation:{open:function(){},close:function(){},both:function(){}}},callbacks:{animation:{open:function(){},close:function(){},both:function(){},freezePage:!0}}},mask:{display:!0,css:{backgroundColor:"black",opacity:.5,filter:"Alpha(opacity=50)"}}},o);return this.each(function(){var o,t,i,a="data-"+e.attr,s="opened"===e.init?"opened":"closed",c=e.overflow?e.overflow:n("html").css("overflow"),d=e.overflow?e.overflow:n("body").css("overflow"),r="left"===e.align?"left":"right",l=e.animation.duration,f=e.animation.easing,u={},p=!0===e.events.callbacks.animation.freezePage,m=function(){n("body, html").css("overflow","hidden")},b=n(this),h=function(n){return n<e.sidebar.width+e.gap?n-e.gap:e.sidebar.width},w=function(){return b.attr(a)},v=function(n){b.attr(a,n)},k=n("<div>").attr(a,"mask"),y=n(e.selectors.trigger),g=e.selectors.quitter?e.selectors.quitter:"a",x=n(window).width(),z={animation:{open:function(){k.fadeIn(l),v("opened"),e.events.on.animation.open()},close:function(){k.fadeOut(l),v("closed"),e.events.on.animation.close()},both:function(){e.events.on.animation.both()}}},I={animation:{open:function(){p&&m(),e.events.callbacks.animation.open()},close:function(){p&&(n("html").css("overflow",c),n("body").css("overflow",d)),e.events.callbacks.animation.close()},both:function(){e.events.callbacks.animation.both()}}},q=function(){u[r]=0,b.animate(u,l,f,function(){I.animation.open(),I.animation.both()}),z.animation.open(),z.animation.both()},j=function(){u[r]=-b.width(),b.animate(u,l,f,function(){I.animation.close(),I.animation.both()}),z.animation.close(),z.animation.both()};(o={position:"fixed",top:parseInt(e.top),bottom:0,width:h(x),zIndex:e.zIndex})[r]="closed"===s?-h(x):0,p&&"opened"===s&&m(),b.css(o).attr(a,s),(t={position:"fixed",top:parseInt(e.top),right:0,bottom:0,left:0,zIndex:e.zIndex-1,display:"none"}).display="opened"===s?"block":"none",i=n.extend(!0,t,e.mask.css),e.mask.display&&k.appendTo("body").css(i),y.click(function(){switch(w()){case"opened":j();break;case"closed":q()}}),b.on("simpler-sidebar-toggle",function(){switch(w()){case"opened":j();break;case"closed":q()}}),k.click(j),b.on("click",g,j),n(window).resize(function(){var o=n(window).width();b.css("width",h(o)),"closed"===w()&&b.css(r,-b.width())})})}});
    
    // adding sidebar
    window.cx_sidebar = {
            
        selector : null,
        state    : 0, // 0 mean closed,
        init : function(cx_sidebar) {

            var THIS = this;

            if ( $("#cx-sidebar-right").length == 0 ) {

                $('body').append(
                    `<div class="cx-sidebar sidebar" id="cx-sidebar-right">
                        <div class="cx-sidebar-wrapper sidebar-wrapper">
                            <div class='cx-sidebar-content'>
                              <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                              </svg>							
							</div>
                        </div>
                    </div>`
                );
            }
            
            THIS.cx_sidebar = $('body').find("#cx-sidebar-right");
            THIS.cx_sidebar_content = THIS.cx_sidebar.find('.cx-sidebar-content');

            THIS.cx_sidebar.simplerSidebar({
                width: 480,
                sidebar : {
                    width :480,
                },
                align: "right",
                zIndex: 9999999, 
                top: 0,
                mask: {
                    display: true,
                    css: {
                      backgroundColor: "black",
                      opacity: 0.5,
                      filter: "Alpha(opacity=50)",
                    }
                },
                selectors: {
                    trigger: "#toggle-sidebar-left",
                    quitter: ".quit-sidebar-left"
                },
                events: {

                    callbacks: {

                        animation: {

                            open: function () {

                                THIS.cx_sidebar_content.addClass("content-loading");
                                                            

                                if ( typeof THIS.open_callback == "function") {

                                    THIS.open_callback(THIS.cx_sidebar_content) 
                                }
                                window.cx_sidebar.state = 1;
                                
                            },
                            close: function () {

                                THIS.cx_sidebar_content.html("");

                                if ( typeof THIS.close_callback == "function") {
                                    
                                    THIS.close_callback(THIS.cx_sidebar_content)    
                                };
                                window.cx_sidebar.state = 0;

                            },
                            both: function () {

                            },
                            freezePage: true,
                        },
                    },
                }
            });
        },
        open:  function(open_callback, close_callback) {

            var THIS = this;

            if ( typeof open_callback == 'function') THIS.open_callback = open_callback;
            if ( typeof close_callback == 'function') THIS.close_callback = close_callback;

            THIS.cx_sidebar.trigger("simpler-sidebar-toggle");

        },
        close : function() {

            var THIS = this;
            if ( THIS.is_opened() ) {
                THIS.cx_sidebar.trigger("simpler-sidebar-toggle");
            }
        },
        is_opened : function() {
            return cx_sidebar.state;
        },
        trigger_toogle: function() {
            this.cx_sidebar.trigger("simpler-sidebar-toggle");
        },
        remove_loading : function() {
            var THIS = this;
            THIS.cx_sidebar_content.removeClass("content-loading");
        },
        get_elem: function() {

            var THIS = this;
            if ( THIS.cx_sidebar ) return THIS.cx_sidebar;
            return null;

        },
        content_default_args: function() {
            return {
                sidebar_class : " custom-sidebar ",
                title : "Sidebar",
                title_icon : null,
            }
        },
        parse_default_args : function (obj) {
            var THIS = this;
            $.each(THIS.content_default_args() , function(kk,vv) {

                if ( typeof obj[kk] == "undefined") {
                    obj[kk] = vv;
                }

            });
            return obj;
        },
        setup_content: function(obj , $content) {
            
            var THIS = this;

            obj = THIS.parse_default_args(obj);

            $content.html('');
            $content.append(`<div class="inner-content ${obj.sidebar_class} "></div>`);
            var inner_content = $content.find('.inner-content');
            var infobox = false;
            inner_content.css('display','none');

            var render_infobox = function(ls) {

                var html = '<div class="cx-sidebar-infobox-wraper">';

                $.each(ls , function(kk,vv) {

                    html += `
                    <div class="cx-sidebar-infobox-item">
                    
                        <div class="sidebar-infobox-item-title">
                            ${ vv.icon ? `<small><i class="infobox-item-title-pictorial fas ${vv.icon}"></i></small>` : ''  }
                            <span class="infobox-item-title" >${vv.label}</span>
                        </div>

                        <div class="infobox-item-value">${vv.value}</div>
                    </div>`
                })
                html += '</div>';
                return html;
            } // function end

            if (typeof obj.infobox != 'undefined' && obj.infobox.length) {
                infobox = true;
            }

            inner_content.html(`
                <div>
                    <div class="cx-sidebar-title">
                        <span class="sidebar-close-btn"> ✕ </span>
                        <p class="wbg-cart-title">
                            ${ obj.title_icon ? `<small><i class="sidebar-title-pictorial sidebar-title-icon fas ${obj.title_icon}" ${ (typeof obj.title_icon_color != 'undefined') ? "style='color:" + obj.title_icon_color + "'" : "" }></i></small>` : ''  }
                            ${ obj.title_image ? `<small><img class="sidebar-title-pictorial sidebar-title-img fas " src='${obj.title_image}'/></small>` : ''  }
                            ${obj.title}
                        </p>
                        <p>${obj.sub_title}</p>
                    </div>

                    ${ infobox ? render_infobox(obj.infobox) : '' }

                    <div class='cx-sidebar-render-content'></div>
                </div>
            `);

            inner_content.find(".sidebar-close-btn").click(function(){
                console.log('close btn click');
                THIS.trigger_toogle();
            });
            return inner_content.find('.cx-sidebar-render-content')
        },
        show_content: function(speed = 300) {

            var THIS = this;
            THIS.remove_loading();
            var content = THIS.cx_sidebar_content.find('.inner-content');
            // console.log(jquery_lib_initilizer);
            if ( typeof jquery_lib_initilizer == "function" ) {
                jquery_lib_initilizer(content);
            }

            THIS.cx_sidebar_content.find('.inner-content').slideDown(speed);
            var height = content.find('.cx-sidebar-footer').outerHeight();
            content.find('.cx-sidebar-render-content').css({
                'padding-bottom' : height  + "px",
            })

        },
        get_content : function() {
            return this.cx_sidebar_content
        }
    }

    $.fn.extend({
        number_feild: function() {
            var set = this;
            return set.each(function(k,v) {

                var elm = $(v);
                
                if ( !elm.hasClass("number_feild_initilized") ) {

                    elm.addClass("number_feild_initilized")
                    elm.attr("type","number");
                    elm.wrap('<div class="number-selector">');
                    elm.parent().prepend('<button type="button" onclick="this.nextElementSibling.stepDown();jQuery(this.nextElementSibling).trigger(\'change\');">-</button>');
                    elm.parent().append('<button type="button" onclick="this.previousElementSibling.stepUp();jQuery(this.previousElementSibling).trigger(\'change\');">+</button>');    
                }
                
                

            })
        },
    })
    
    $(function() {
        cx_sidebar.init();  
    })
    
    
})(jQuery) 